const RSVP_COUNT_KEYS = ["yes", "no", "unanswered", "other", "total"];

export function getWhatsAppRsvpCount(summary, key) {
  if (!RSVP_COUNT_KEYS.includes(key)) return null;
  const count = summary?.[key];
  return Number.isSafeInteger(count) && count >= 0 ? count : null;
}

export function formatWhatsAppRsvpSummary(summary) {
  const keys = ["yes", "no", "unanswered"];
  const counts = keys.map((key) => getWhatsAppRsvpCount(summary, key));
  if (counts.some((count) => count === null)) return null;
  return counts.join(" / ");
}
